module.exports = __webpack_public_path__ + "images/emoji/closed_book.d8ccb23f0dffaa8104a3.png";